<template>
  <div class="activate-company account-suspended">
    <div class="landing-page-wrapper">
      <div class="landing-page-content">
        <div class="activate-company__hero">
          <h1 class="page-title">
            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="do-not-enter" class="svg-inline--fa fa-do-not-enter" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
              <path fill="currentColor" d="M256 0C114.6 0 0 114.6 0 256c0 141.4 114.6 256 256 256s256-114.6 256-256C512 114.6 397.4 0 256 0zM415.9 304H96.05C87.21 304 79.95 296.9 79.95 288V224c0-8.875 7.266-16 16.11-16h319.9c8.84 0 16.11 7.125 16.11 16v64C432.1 296.9 424.8 304 415.9 304z"></path>
            </svg>
            Your account is suspended.
          </h1>
          <p class="page-description">
            We can't take you to your dashboard because your organisation subscription expired on {{ expiryDate }}. To resume your work with ClearAssured, please renew your subscription or get in touch with your designated billing contact:
          </p>
          <div class="activate-company__billing-data">
            <div>
              <div class="activate-company__billing-data--label">Billing contact:</div>
              <div class="activate-company__billing-data--value">{{ billingContact }}</div>
            </div>
            <div>
              <div class="activate-company__billing-data--label">Billing email:</div>
              <div class="activate-company__billing-data--value">{{ billingEmail }}</div>
            </div>
            <div>
              <div class="activate-company__billing-data--label">Billing phone:</div>
              <div class="activate-company__billing-data--value">{{ billingPhone }}</div>
            </div>
          </div>
          <router-link :to="{ name: 'billing-profile' }" class="activate-company__billing-renew" v-if="canRenew">
            Renew subscription
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  export default {
    name: 'account-suspended',
    computed: {
      ...mapGetters([
        'profile'
      ]),
      expiryDate () {
        if (!this.profile || !this.profile.company || !this.profile.company.subscription_end) {
          return ''
        }
        let expiryOn = new Date(this.profile.company.subscription_end)
        if (isNaN(this.profile.company.subscription_end) || isNaN(Date.parse(this.profile.company.subscription_end))) {
          return ''
        }
        let dd = String(expiryOn.getDate()).padStart(2, '0')
        let mm = String(expiryOn.getMonth() + 1).padStart(2, '0')
        let yyyy = expiryOn.getFullYear()
        return dd + '.' + mm + '.' + yyyy
      },
      billingContact () {
        if (!this.profile || !this.profile.company) {
          return ''
        }
        return [this.profile.company.billing_first_name || '', this.profile.company.billing_last_name || ''].filter(n => n.trim() !== '').join(' ')
      },
      billingEmail () {
        if (!this.profile || !this.profile.company) {
          return ''
        }
        return this.profile.company.billing_email
      },
      billingPhone () {
        if (!this.profile || !this.profile.company) {
          return ''
        }
        return this.profile.company.billing_phone
      },
      canRenew () {
        if (!this.profile) {
          return false
        }
        return this.profile.role.slug === 'ca'
      }
    },
    data () {
      return {}
    },
    watch: {
      profile (value) {
        if (value && value.company) {
          if (!value.company.suspended) {
            this.$router.push('/')
          }
        }
      }
    },
    methods: {
      ...mapActions([
        'getUser'
      ])
    },
    created () {
      document.title = 'Clear Assured – account suspended'
    },
    mounted () {
      this.getUser()
    }
  }
</script>

<style src="@/assets/scss/main/landing-page.scss" lang="scss" scoped></style>
<style src="@/assets/scss/components/subscriptions/activate-company.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// AccountSuspended.vue?19003562